import {
  Button,
  ButtonProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row, StackProps } from "@rui/Stack";

export const DeepDiveSectionHeader = styled((props: StackProps) => (
  <Row variant="apart" {...props} />
))(({ theme }) => ({
  minHeight: "28px",
  paddingBottom: theme.spacing(1),
}));

export const DeepDiveSectionHeading = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryMed" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  textTransform: "uppercase",
}));

export const DeepDiveMenuButton = styled((props: ButtonProps) => (
  <Button disableRipple variant="outlined" {...props} />
))(({ theme }) => ({
  borderColor: theme.palette.shades.neutral[100],
  color: theme.palette.shades.neutral[500],
  borderRadius: "4px",
  height: "28px",
  minHeight: "28px",
  padding: "4px 10px",
  "& svg": {
    height: "16px",
    width: "16px",
  },
}));
